import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSnowshoeNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M1.62 12.05l1.66 26.12a7.953 7.953 0 004.2 6.54L12 47.13l4.52-2.4a7.98 7.98 0 004.2-6.54l1.66-26.12A10.407 10.407 0 002.206 7.874a10.337 10.337 0 00-.586 4.176zm17.3 22.943h-3.9v2h3.77l-.07 1.067a5.943 5.943 0 01-3.15 4.9L13 44.33v-4.337h-2v4.337l-2.57-1.38a5.958 5.958 0 01-3.15-4.9l-.07-1.057h3.8v-2H5.09L4.45 25H7v4a5 5 0 1010 0v-4h2.55l-.63 9.993zM9 29v-9a3 3 0 016 0v9a3 3 0 01-6 0zm10.68-6H17v-3l.622-6.989A5.51 5.51 0 0017.589 12h2.791l-.7 11zM13 3.06a8.3 8.3 0 015.12 2.59A8.219 8.219 0 0120.28 10h-3.319a5.56 5.56 0 00-3.96-2.889V3.06zm1.647 7.1a3.587 3.587 0 01.98 2.694l-.305 3.413a4.96 4.96 0 00-6.643.009l-.3-3.4a3.63 3.63 0 016.272-2.712l-.004-.004zM5.87 5.65A8.353 8.353 0 0111 3.06v4.053A5.572 5.572 0 007.031 10h-3.31a8.276 8.276 0 012.15-4.35zM6.41 12c-.04.34-.05.683-.03 1.025L7 20v3H4.32l-.7-11h2.79zm22-7.72a10.339 10.339 0 00-2.79 7.77l1.66 26.12a7.953 7.953 0 004.2 6.54L36 47.13l4.52-2.4a7.98 7.98 0 004.2-6.54l1.66-26.12a10.407 10.407 0 00-17.97-7.79zm10.237 5.885a3.587 3.587 0 01.98 2.694l-.3 3.413a4.96 4.96 0 00-6.643.009l-.3-3.4a3.631 3.631 0 016.272-2.712l-.009-.004zM39 20v9a3 3 0 01-6 0v-9a3 3 0 016 0zM29.87 5.65A8.353 8.353 0 0135 3.06v4.053A5.572 5.572 0 0031.031 10h-3.31a8.276 8.276 0 012.15-4.35zM27.62 12h2.79c-.04.34-.05.683-.03 1.025L31 20v3h-2.68l-.7-11zm15.3 22.989h-3.9v2h3.77l-.07 1.067a5.943 5.943 0 01-3.15 4.9L37 44.33v-4.337h-2v4.337l-2.57-1.38a5.958 5.958 0 01-3.15-4.9l-.07-1.057h3.8v-2h-3.92L28.45 25H31v4a5 5 0 1010 0v-4h2.55l-.63 9.989zM43.68 23H41v-3l.622-6.989A5.6 5.6 0 0041.589 12h2.791l-.7 11zM37 3.06a8.3 8.3 0 015.12 2.59A8.219 8.219 0 0144.28 10h-3.319a5.56 5.56 0 00-3.96-2.889V3.06z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowshoeNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsSnowshoeNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSnowshoeNormalLarge;
